import { Component, OnInit, Input } from '@angular/core';
import { reportData } from '../animations';

@Component({
  selector: 'app-report-analysis-icon',
  templateUrl: './report-analysis-icon.component.html',
  styleUrls: ['./report-analysis-icon.component.scss'],
  animations: [reportData]
})
export class ReportAnalysisIconComponent implements OnInit {
  @Input() imgSrc: string;
  @Input() label: string;
  @Input() additionalInfo: string;
  @Input() value: string = null;
  @Input() isFlipped: boolean;
  @Input() smallValue: boolean;
  @Input() customStyle: {};
  @Input() messageIconClass: string;
  @Input() messageText: string;

  constructor() {}

  ngOnInit() {}
}
